class MadrinaEdit {
  constructor(data = {}) {
    this.idTractocamion = data.idTractocamion || 0;
    this.vin = data.vin || "";
    this.numeroEconomico = data.numeroEconomico || "";
    this.placas = data.placas || "";
    this.placasUsa = data.placasUsa || "";
    this.tipoTrailer = data.tipoTrailer || "";
    this.numeroTrailer = data.numeroTrailer || "";
    this.idTipoVehiculo = data.idTipoVehiculo || 0;
    this.modelo = data.modelo || "";
    this.idAno = data.idAno || 0;
    this.anio = data.anio || "";
    this.nombre = data.nombre || "";
    this.noEmpleado = data.noEmpleado || "";
    this.idEmpleado = data.idEmpleado || 0;
    this.idUbicacion = data.idUbicacion || 0;
    this.ubicacion = data.ubicacion || "";
    this.estatus = data.estatus || true;
  }
}

class MadrinaAdd {
  constructor(data = {}) {
    this.idTractocamion = data.idTractocamion || 0;
    this.vin = data.vin || "";
    this.numeroEconomico = data.numeroEconomico || "";
    this.placas = data.placas || "";
    this.placasUsa = data.placasUsa || "";
    this.tipoTrailer = data.tipoTrailer || "";
    this.numeroTrailer = data.numeroTrailer || "";
    this.idTipoVehiculo = data.idTipoVehiculo || 0;
    this.modelo = data.modelo || "";
    this.idAno = data.idAno || 0;
    this.anio = data.anio || "";
    this.nombre = data.nombre || "";
    this.noEmpleado = data.noEmpleado || "";
    this.idEmpleado = data.idEmpleado || 0;
    this.idUbicacion = data.idUbicacion || 0;
    this.ubicacion = data.ubicacion || "";
    this.estatus = data.estatus || true;
  }
}

export { MadrinaEdit, MadrinaAdd };
